<template>
  <div>
    <v-progress-linear class="mt-2" v-if="loadingAddons" indeterminate color="primary"></v-progress-linear>
    <template v-if="listOfAddons && listOfAddons.length > 0">
      <v-form ref="addonsForm">
        <v-container fluid class="pa-1">
          <v-simple-table dense class="elevation-1 bordered--table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th width="50%">{{ $t('message.customer.productGroup') }}</th>
                  <th width="25%">{{ $t('message.product.shipment') }}</th>
                  <th width="25%">{{ $t('message.product.other_per') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in listOfAddons" :key="item.id">
                  <td>{{ item.name }}</td>
                  <td>
                    <v-text-field hide-details @change="saveAddonValues" :rules="$_discountValidation" dense v-model="item.shipment"> </v-text-field>
                  </td>
                  <td>
                    <v-text-field hide-details @change="saveAddonValues" :rules="$_discountValidation" dense v-model="item.other"></v-text-field>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
      </v-form>
    </template>
    <v-alert prominent text v-else type="info" class="mt-2">
      <v-row align="center">
        <v-col class="grow">{{ $t('message.customer.noProductGroupsFound') }}</v-col>
      </v-row>
    </v-alert>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      customerId: this.$route.params.crm_id,
      listOfAddons: [],
      loadingAddons: false
    }
  },
  computed: {
    ...mapState(['listOfProductGroups'])
  },
  mounted () {
    if (this.customerId) {
      this.$store.dispatch('getProductGroups')
        .then((response) => {
          this.defaultAddons()
        })
    }
  },
  methods: {
    defaultAddons () {
      let addons = [...this.listOfProductGroups]
      let addonsList = []
      for (let i = 0; i < addons.length; i++) {
        addonsList.push({
          productgroupid: addons[i].id,
          name: addons[i].name,
          supplierid: this.customerId,
          shipment: '0',
          other: '0' })
      }
      this.getAllAddonsHandler(addonsList)
    },
    getAllAddonsHandler (addons) {
      this.loadingAddons = true
      let query = {
        'expand': [{
          'Model': 'ProductGroup',
          'on_field': 'id',
          'on_parent_field': 'ProductGroupId',
          'select': ['Name']
        }],
        'filter': `supplierid eq ${this.customerId}`
      }
      this.$_executeApi('post', `transportationcosts/query`, query)
        .then((response) => {
          let model = response.data
          let transformData = { number: { list: ['shipment', 'other'], format: 'replaceDotWithComma' } }
          let addedList = this.$_formatListModel(model, transformData)
          let resultAddons = []
          if (addons && addons.length > 0) {
            for (let i = 0; i < addons.length; i++) {
              let hasIndex = addedList.findIndex(x => x.productgroupid === addons[i].productgroupid)
              if (hasIndex > -1) {
                resultAddons.push(Object.assign({ ...addedList[hasIndex] }, { name: addons[i].name }))
              } else {
                let item = {
                  productgroupid: addons[i].productgroupid,
                  name: addons[i].name,
                  supplierid: this.customerId,
                  shipment: '0',
                  other: '0'
                }
                resultAddons.push(item)
              }
            }
          }
          this.listOfAddons = resultAddons
          this.loadingAddons = false
        })
    },
    saveAddonValues () {
      return new Promise((resolve, reject) => {
        if (this.$refs.addonsForm) {
          if (this.$refs.addonsForm.validate()) {
            this.addonsLoading = true
            let transformData = { number: { list: ['shipment', 'other'], format: 'replaceCommaWithDot' } }
            let model = this.$_formatListModel(this.listOfAddons, transformData)
            this.$_executeApi('post', `transportationcosts/bulk_save`, model)
              .then((response) => {
                this.addonsLoading = false
                this.defaultAddons()
                resolve()
              })
              .catch((err) => {
                reject(err)
              })
          } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        } else resolve()
      })
    }
  }
}
</script>
